import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, LoadCart } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import enablePlaceOrderShippingHandling from "@tCentro/Handlers/EnablePlaceOrderShippingHandlingHandler";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel,
    { updateCartApiParameter: UpdateCartApiParameter }
>;

export const LoadCartExtended: HandlerType = props => {
    props.dispatch(enablePlaceOrderShippingHandling({ isSaveOrderShippingEnabled: true }));
    props.dispatch(loadCurrentCart({ shouldLoadFullCart: true }));
};

replaceInChain(chain, LoadCart, LoadCartExtended);
